export default "__VITE_ASSET__2e90d6f6__"